import { BusinessSectionNode, RawBusinessSection } from "../../../interfaces/BusinessSectionObject";

/** Recursively normalizes one raw section node — guarantees `children` is
 *  always an array (never null/undefined), unlike the raw wire shape. */
export function convertRawBusinessSection(raw: RawBusinessSection): BusinessSectionNode {
  return {
    sectionId: raw.sectionId,
    businessId: raw.businessId,
    parentSectionId: raw.parentSectionId ?? null,
    name: raw.name,
    displayOrder: raw.displayOrder ?? null,
    children: Array.isArray(raw.children) ? raw.children.map(convertRawBusinessSection) : [],
  };
}

/** Converts the `contents` array from GET /business-sections/business/{id}
 *  (a list of root sections, each nested to any depth) into UI nodes. */
export function convertRawBusinessSectionTree(
  raw: RawBusinessSection[] | null | undefined
): BusinessSectionNode[] {
  return Array.isArray(raw) ? raw.map(convertRawBusinessSection) : [];
}
